<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Navigation -->
    <nav class="bg-white shadow-sm border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <!-- Logo -->
          <router-link to="/" class="flex items-center space-x-2">
            <div class="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
              <Share2 class="w-5 h-5 text-white" />
            </div>
            <span class="text-xl font-bold text-gray-900">{{ config.app.name }}</span>
          </router-link>

          <!-- Navigation Links -->
          <div class="flex items-center space-x-4">
            <router-link
              v-if="!authStore.isAuthenticated"
              to="/login"
              class="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
            >
              Admin Login
            </router-link>
            
            <template v-if="authStore.isAuthenticated">
              <router-link
                to="/admin"
                class="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
              >
                Dashboard
              </router-link>
              
              <div class="flex items-center space-x-3">
                <span class="text-sm text-gray-600">{{ authStore.userEmail }}</span>
                <button
                  @click="handleSignOut"
                  class="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Sign Out
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="flex-1">
      <router-view />
    </main>

    <!-- Notifications -->
    <NotificationContainer />

    <!-- Loading Overlay -->
    <LoadingOverlay v-if="authStore.loading" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { Share2 } from 'lucide-vue-next'
import { useAuthStore } from '@/stores/auth'
import { useNotificationStore } from '@/stores/notification'
import { config } from '@/config'
import NotificationContainer from '@/components/NotificationContainer.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

const authStore = useAuthStore()
const notificationStore = useNotificationStore()

onMounted(async () => {
  // Initialize authentication state
  await authStore.initializeAuth()
})

const handleSignOut = async () => {
  try {
    await authStore.signOut()
    notificationStore.success('Signed out successfully')
  } catch (error) {
    notificationStore.error('Failed to sign out')
  }
}
</script>
